import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { consumeSkipAutoScroll } from '../services/assistant/scrollControl'

function ScrollToTop() {
  const { pathname } = useLocation()

  useEffect(() => {
    // The assistant may navigate specifically to scroll to a section; in that
    // case skip the reset so it doesn't yank the user back to the top.
    if (consumeSkipAutoScroll()) return
    window.scrollTo(0, 0)
  }, [pathname])

  return null
}

export default ScrollToTop
